module.exports = __webpack_public_path__ + "static/media/pupular2.c1c87465.jpg";